import { DatePipe } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
} from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { LoadingController } from "@ionic/angular";
import { ToastComponent } from "src/app/core-files/loaders/toast-messages";
import { SharedService } from "src/app/core-files/shared.service.";
import { AddAgentPropertiesService } from "src/app/services/add-agent-properties.service";
import { AgentCallingService } from "src/app/services/agent-calling.service";
import { EncryptionService } from "src/app/services/encryption.service";
import { LeadsService } from "src/app/services/leads.service";
import { NewProjectServices } from "src/app/services/new-project.service";
import { SharedServices } from "src/app/services/shared.service";
import { SidebarService } from "src/app/services/sidebar.service";
import { Capacitor } from '@capacitor/core';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';

@Component({
  selector: "app-delete-confirm-dialog",
  templateUrl: "./delete-confirm-dialog.component.html",
  styleUrls: ["./delete-confirm-dialog.component.scss"],
  standalone: false
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeleteConfirmDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sidebarService: SidebarService,
    private loadingController: LoadingController,
    private addAgentPropertiesService: AddAgentPropertiesService,
    private leadServices: LeadsService,
    private toastComponent: ToastComponent,
    private agentCallingService: AgentCallingService,
    private shareService: SharedService,
    private newProjectServices: NewProjectServices,
    private sharedServices: SharedServices,
    private encryptionService: EncryptionService,
    private router: Router
  ) { }

  ngOnInit() { }

  private blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const result = reader.result as string;
        // result is like: data:application/octet-stream;base64,AAAA
        const base64 = result.split(',')[1];
        resolve(base64);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  private async ensureFilePermissions(): Promise<void> {
    try {
      if (Capacitor.getPlatform() === 'android') {
        const status: any = await Filesystem.checkPermissions();
        if (status?.publicStorage !== 'granted') {
          await Filesystem.requestPermissions();
        }
      }
    } catch {
      // Ignore permission check errors; write will surface any real issues
    }
  }

  private async saveBlobToDevice(blob: Blob, fileName: string): Promise<string> {
    await this.ensureFilePermissions();
    const base64 = await this.blobToBase64(blob);

    // 1) Try Documents (works on both Android and iOS and is app-visible)
    try {
      await Filesystem.writeFile({
        path: fileName,
        data: base64,
        directory: Directory.Documents,
        recursive: true,
      });
      const { uri } = await Filesystem.getUri({ path: fileName, directory: Directory.Documents });
      return uri;
    } catch (e1) {
      // 2) Android fallback: ExternalStorage/Download (may require permissions and can fail on scoped storage)
      try {
        await Filesystem.writeFile({
          path: `Download/${fileName}`,
          data: base64,
          directory: Directory.ExternalStorage,
          recursive: true,
        });
        const { uri } = await Filesystem.getUri({ path: `Download/${fileName}`, directory: Directory.ExternalStorage });
        return uri;
      } catch (e2) {
        // 3) Final fallback: Data directory (always available, not user-visible)
        const saved = await Filesystem.writeFile({
          path: fileName,
          data: base64,
          directory: Directory.Data,
          recursive: true,
        });
        return saved.uri;
      }
    }
  }
  async deleteItem(deleteData) {
    if (deleteData.type === "logout") {
      localStorage.removeItem("tk_n");
      localStorage.removeItem("a_n_d");
      localStorage.removeItem("ag_u_d");
      localStorage.removeItem("i_Ex_p");
      localStorage.removeItem("i_a_nt");
      localStorage.removeItem("u_ty_i");
      localStorage.clear();

      setTimeout(() => {
        
              this.sharedServices.setIsLoggedIn(false);
              this.leadServices.setuserLogoutLogin(true);
        localStorage.setItem("lg_d_i", this.encryptionService.encryptUsingAES256("false"));
      },1000);
      this.router.navigate(["agent-home/agent-tab/home"]);
      this.toastComponent.showToast("Logout Successfully", "success");
      return;
    }

    const loadingCtrl = await this.loadingController.create({
      cssClass: "my-custom-class",
      message: "Deleting...",
    });

    if (deleteData.type === "team") {
      await loadingCtrl.present();
      this.leadServices.DeleteTeam(this.data.Id).subscribe({
        next: async (res) => {
          this.leadServices.setTeamChanged(true);
          await loadingCtrl.dismiss();
          this.toastComponent.showToast("Team Deleted Successfully", "success");
        },
        error: async (err) => {
          await loadingCtrl.dismiss();
          this.toastComponent.showToast("Something wrong try again", "danger");
        }
      });
    }
    if (deleteData.type === "user") {
      await loadingCtrl.present();
      this.leadServices.DeleteAgentUser(this.data.Id).subscribe({
        next: async (res) => {
          this.leadServices.setUserChanged(true);
          await loadingCtrl.dismiss();
          this.toastComponent.showToast("User Deleted Successfully", "success");
        },
        error: async (err) => {
          this.leadServices.setUserChanged(true);
          await loadingCtrl.dismiss();
          this.toastComponent.showToast("Something wrong try again", "danger");
        }
      });
    }
    if (deleteData.type === "property") {
      await loadingCtrl.present();
      this.sidebarService.DeleteMyPost(deleteData.Id).subscribe({
        next: async (res) => {
          this.addAgentPropertiesService.setPropertyPost(true);
          await loadingCtrl.dismiss();
          this.toastComponent.showToast(
            "Property Deleted Successfully",
            "success"
          );
        },
        error: async (err) => {
          this.addAgentPropertiesService.setPropertyPost(true);
          await loadingCtrl.dismiss();
          this.toastComponent.showToast("Something wrong try again", "danger");
        }
      });
    }
    if (deleteData.type === "lead") {
      await loadingCtrl.present();
      this.leadServices.DeleteLead(deleteData.Id).subscribe({
        next: async (res) => {
          this.addAgentPropertiesService.setPropertyPost(true);
          await loadingCtrl.dismiss();
          this.toastComponent.showToast("Lead Deleted Successfully", "success");
        },
        error: async (err) => {
          this.addAgentPropertiesService.setPropertyPost(true);
          await loadingCtrl.dismiss();
          this.toastComponent.showToast("Something wrong try again", "danger");
        }
      });
    }
    if (deleteData.type === "Remove team from lead") {
      await loadingCtrl.present();
      this.leadServices.RemoveTeamFromLead(this.data.Id).subscribe({
        next: async (res) => {
          this.leadServices.setTeamRemove(true);
          await loadingCtrl.dismiss();
          this.toastComponent.showToast(
            "Team Removed From Lead Successfully",
            "success"
          );
        },
        error: async (err) => {
          this.leadServices.setTeamRemove(true);
          await loadingCtrl.dismiss();
          this.toastComponent.showToast("Something wrong try again", "danger");
        }
      });
    }
    if (deleteData.type === 'contact') {
      let deleteObject: any = {
        ContactNumberId: this.data.Id
      }
      this.agentCallingService.DeleteContacts(deleteObject).subscribe({
        next: async (res) => {
          this.shareService.setCallingResponseSave(true);
          await loadingCtrl.dismiss();
          this.toastComponent.showToast("Contact Deleted Successfully", "success");
        },
        error: async (err) => {
          await loadingCtrl.dismiss();
          this.toastComponent.showToast("Something wrong try again", "danger");
        }
      });
    }

    if (deleteData.type === 'contact lead') {

      this.agentCallingService.DeleteAgentCallingLead(this.data.Id).subscribe({
        next: async (res) => {
          this.shareService.setCallingLead(true);
          await loadingCtrl.dismiss();
          this.toastComponent.showToast("Calling Lead Deleted Successfully", "success");
        },
        error: async (err) => {
          await loadingCtrl.dismiss();
          this.toastComponent.showToast("Something wrong try again", "danger");
        }
      });
    }
    if (deleteData.type === 'delete agent project') {

      this.newProjectServices.RemoveProject(this.data.Id).subscribe({
        next: async (res) => {
          // this.shareService.setCallingLead(true);
          await loadingCtrl.dismiss();
          this.toastComponent.showToast("Project Deleted Successfully", "success");
        },
        error: async (err) => {
          await loadingCtrl.dismiss();
          // this.toastComponent.showToast("Something wrong try again", "danger");
          this.toastComponent.showToast("Project Deleted Successfully", "success");
        }
      });
    }

    if (deleteData.type === 'ProjectProperty') {

      this.newProjectServices.DeleteProjectProperty(this.data.Id).subscribe({
        next: async (res) => {
          this.shareService.setSaveProjectProperty(true);
          await loadingCtrl.dismiss();
          this.toastComponent.showToast("Project property Deleted Successfully", "success");
        },
        error: async (err) => {
          this.shareService.setSaveProjectProperty(true);
          await loadingCtrl.dismiss();
          this.toastComponent.showToast("Project property Deleted Successfully", "success");
        }
      });
    }
    if (deleteData.type === 'project-image') {

      this.newProjectServices.DeleteProjectImage(this.data.Id).subscribe({
        next: async (res) => {
          this.shareService.setProjectImageDeleted(true);
          await loadingCtrl.dismiss();
          this.toastComponent.showToast("Project image Deleted Successfully", "success");
        },
        error: async (err) => {
          this.shareService.setProjectImageDeleted(true);
          await loadingCtrl.dismiss();
          this.toastComponent.showToast("Project image Deleted Successfully", "success");
        }
      });
    }
    if (deleteData.type === 'property-image') {

      this.addAgentPropertiesService.DeletePropertyImage(this.data.Id).subscribe({
        next: async (res) => {
          this.shareService.setPropertyImageDeleted(true);
          await loadingCtrl.dismiss();
          this.toastComponent.showToast("Property image Deleted Successfully", "success");
        },
        error: async (err) => {
          this.shareService.setPropertyImageDeleted(true);
          await loadingCtrl.dismiss();
          this.toastComponent.showToast("Property image Deleted Successfully", "success");
        }
      });
    }
    if (deleteData.type === 'export response') {
      await loadingCtrl.present();
      this.leadServices.ExportCallingResponseData(this.data.Id).subscribe({
        next: async (resp: any) => {
          try {
            const blob: Blob = resp.body;
            if (!(blob instanceof Blob) || blob.size === 0) {
              this.toastComponent.showToast('File empty or invalid', 'danger');
              return;
            }

            if (blob.type === 'application/json') {
              const text = await blob.text();
              console.error('Server returned JSON instead of file:', text);
              this.toastComponent.showToast('Export failed', 'danger');
              return;
            }

            let fileName = 'ExportResponse' + new Date().getTime() + '.xlsx';
            const cd = resp.headers?.get?.('Content-Disposition');
            if (cd) {
              const m = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(cd);
              if (m && m[1]) fileName = m[1].replace(/['"]/g, '');
            }

            if (Capacitor.getPlatform() !== 'web') {
              // Native (Android/iOS): save to device and offer Share
              try {
                const uri = await this.saveBlobToDevice(blob, fileName);
                try {
                  // Prefer file sharing with files array (Capacitor Share v5+). Fallback to url if not supported.
                  await (Share as any).share({ title: fileName, files: [uri], dialogTitle: 'Share file' });
                } catch {
                  await Share.share({ title: fileName, url: uri, dialogTitle: 'Share file' });
                }
                this.toastComponent.showToast('File saved to device', 'success');
              } catch (err) {
                console.error('Save failed:', err);
                this.toastComponent.showToast('Could not save file on device', 'danger');
              }
            } else {
              // Web: trigger browser download
              const url = URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = fileName;
              document.body.appendChild(a);
              a.click();
              a.remove();
              setTimeout(() => URL.revokeObjectURL(url), 2000);
            }

            this.toastComponent.showToast('Export response successful', 'success');
          } catch (e) {
            console.error(e);
            this.toastComponent.showToast('Download error', 'danger');
          } finally {
            await loadingCtrl.dismiss();
          }
        },
        error: async (err) => {
          console.error('HTTP error:', err);
          await loadingCtrl.dismiss();
          this.toastComponent.showToast(err?.message || 'Something wrong try again', 'danger');
        }
      });
    }
    if (deleteData.type === 'export calling leads') {
      await loadingCtrl.present();

      this.leadServices.ExportCallingLeads(this.data.Id).subscribe({
        next: async (resp: any) => {
          try {
            await loadingCtrl.dismiss();

            const blob: Blob = resp.body;
            if (!(blob instanceof Blob) || blob.size === 0) {
              this.toastComponent.showToast('File empty or invalid', 'danger');
              return;
            }

            // Detect unexpected JSON (means server returned error JSON but you asked for blob)
            if (blob.type === 'application/json') {
              const text = await blob.text();
              console.error('Server returned JSON instead of file:', text);
              this.toastComponent.showToast('Export failed (server returned JSON)', 'danger');
              return;
            }

            // Try filename from headers
            let fileName = 'ExportedCallingLeads.xlsx';
            const cd = resp.headers?.get?.('Content-Disposition');
            if (cd) {
              const m = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(cd);
              if (m && m[1]) fileName = m[1].replace(/['"]/g, '');
            }

            if (Capacitor.getPlatform() !== 'web') {
              // Native (Android/iOS): save to device and offer Share
              try {
                const uri = await this.saveBlobToDevice(blob, fileName);
                try {
                  await (Share as any).share({ title: fileName, files: [uri], dialogTitle: 'Share file' });
                } catch {
                  await Share.share({ title: fileName, url: uri, dialogTitle: 'Share file' });
                }
                this.toastComponent.showToast('File saved to device', 'success');
              } catch (err) {
                console.error('Save failed:', err);
                this.toastComponent.showToast('Could not save file on device', 'danger');
              }
            } else {
              // Web: trigger browser download
              const url = URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = fileName;
              document.body.appendChild(a); // needed for Firefox
              a.click();
              a.remove();
              setTimeout(() => URL.revokeObjectURL(url), 2000);
            }

            this.toastComponent.showToast('Export calling leads successful', 'success');
          } catch (e) {
            console.error(e);
            this.toastComponent.showToast('Download error', 'danger');
          }
        },
        error: async (err) => {
          await loadingCtrl.dismiss();
          console.error('HTTP error:', err);
          this.toastComponent.showToast(err?.message || 'Something wrong try again', 'danger');
        }
      });
    }
  }
}
